import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "../service";

export const addCategoryAction = createAsyncThunk(
  "admin/addCategoryAction",
  async (addCategoryData, { rejectWithValue }) => {
    try {
      const { admin_id } = JSON.parse(localStorage.getItem("userData"));
      const data = {
        name: addCategoryData?.category,
        status: true,
        admin_id: admin_id,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_TEST_API}/category`,
        data,
        { headers: myHeaders() }
      );
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.clear();
        window.location.assign("/");
      }
      if (error) {
        return rejectWithValue(error.message);
      }
    }
  }
);
